<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3">
      <search-form :fields="search" />
    </el-button-group>

    <el-table :data="feedBack" resource="feed-backs">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="user_id" label="代理信息" />
      <el-table-column prop="contact_way" label="联系方式" />
      <el-table-column prop="opinions" label="反馈意见" width="300" />
      <el-table-column label="图片">
        点击查看
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="danger" disable-transitions>{{ scope.row.status_text }}</el-tag>
          <el-tag v-if="scope.row.status === 1" type="success" disable-transitions>{{ scope.row.status_text }}</el-tag>
          <el-tag v-if="scope.row.status === 2" type="warning" disable-transitions>{{ scope.row.status_text }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="反馈时间" width="170" />
      <el-table-column label="操作" width="150">
        <template #default="{ row, $index }">
          <el-button-group>
            <!-- TODO: 处理详情 -->
            <row-to-edit button-text="处理" />
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getFeedBack } from '@/api/feed-backs'
import RowDestroy from '@c/LzTable/RowDestroy'
import RowToEdit from '@c/LzTable/RowToEdit'

export default {
  name: 'Index',
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
  },
  data() {
    return {
      search: [
        // TODO:
        // - 条件 （手机号/姓名/昵称）
        // - 提交时间段
        {
          field: 'id',
          label: 'ID',
        },
        {
          field: 'status',
          label: '状态',
          type: 'el-select',
          options: [
            { id: 0, name: '未解决' },
            { id: 1, name: '已解决' },
            { id: 2, name: '不予处理' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
      ],
      feedBack: [],
      page: null,
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        const {
          data: { data, meta },
        } = await getFeedBack(newVal.query)
        this.feedBack = data
        this.page = meta
      },
      immediate: true,
    },
  },
}
</script>
